const baseOptions = [
  {
    name: "Color",
    type: "Section",
    fields: [
      {
        name: "alternatingRowStyle",
        type: "Boolean",
      },
    ],
  },
  {
    name: "General",
    type: "Section",
    fields: [
      {
        name: "frozenColumns",
        type: "Int",
      },
      {
        name: "page",
        type: "list",
        options: ["enable", "disable"]
      },
      {
        name: "pageSize",
        type: "Int",
      },
      {
        name: "showRowNumber",
        type: "Int",
      },
    ],
  },
];

const options = [];

export default {
  baseOptions,
  options,
};
